import { NgModule } from '@angular/core';

import JobTitlesModule from "./jobtitles/jobtitles.module";
import JobRoleTypesModule from "./jobroletypes/jobroletypes.module";
import WorkplacesModule from "./workplaces/workplaces.module";
import AuthoritiesModule from "./authorities/authorities.module";
import CompetenceGroupsModule from "./competencegroups/competencegroups.module";
import { CompetenceTypesModule } from "./competencetypes/competencetypes.module";
import { ActivityTypesModule } from "./activitytypes/activitytypes.module";
import CVCompetenceGroupsModule from "./cvcompetencegroups/cvcompetencegroups.module";
import ApplicationUsersModule from "./applicationusers/application-users.module";
import { SummationGroupsModule } from "./summationgroups/summation-groups.module";
import { RequirementsModule } from "./requirements/requirements.module";
import { RequirementSectionsModule } from "./requirementsections/requirement-sections.module";
import { CvCompetenceTypesModule } from "./cvcompetencetypes/cv-competence-types.module";
import { settingsState } from "./settings.states";
import { UIRouterModule } from "@uirouter/angular";

let STATES = [settingsState];

@NgModule({
    imports: [
        JobTitlesModule,
        JobRoleTypesModule,
        WorkplacesModule,
        AuthoritiesModule,
        CompetenceGroupsModule,
        CompetenceTypesModule,
        CVCompetenceGroupsModule,
        ActivityTypesModule,
        ApplicationUsersModule,
        SummationGroupsModule,
        RequirementsModule,
        RequirementSectionsModule,
        CvCompetenceTypesModule,
        UIRouterModule.forChild({ states: STATES })
    ],
    declarations: []
})
export default class SettingsModule {
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/settings/settings.module.ts